import React from "react";
import _ from "lodash";
import T from "prop-types";
import moment from "moment";
import SummaryStat from "../SummaryStat";
import { dollar, percent, number, numberAndPercent } from "../format";

export default function Summary({ stats, context }) {
  return context === "repair" ? (
    <RepairStationStatsSummary stats={stats} />
  ) : (
    <StandardCompanyStatsSummary stats={stats} />
  );
}

Summary.propTypes = {
  stats: T.shape({}),
  context: T.oneOf(["standard", "repair"])
};

function StandardCompanyStatsSummary({ stats }) {
  const year = moment().year();

  return (
    <div>
      <SummaryStat
        label="IQs - 6 mos"
        value={number(_.get(stats, "purchases.iqs_6_months_count"))}
      />
      <SummaryStat
        label="OQs - 6 mos"
        value={number(_.get(stats, "sales.oqs_6_months_count"))}
      />
      <SummaryStat
        label="POs - 6 mos"
        value={number(_.get(stats, "purchases.purchases_6_months_count"))}
      />
      <SummaryStat
        label="SOs - 6 mos"
        value={number(_.get(stats, "sales.sales_6_months_count"))}
      />
      <SummaryStat
        label="PO/IQ - 6 mos"
        value={percent(_.get(stats, "purchases.po_to_iq_6_months_percent"))}
      />
      <SummaryStat
        label="SO/OQ - 6 mos"
        value={percent(_.get(stats, "sales.so_to_oq_6_months_percent"))}
      />
      <SummaryStat
        label={`Purchases - ${year}`}
        value={dollar(_.get(stats, "purchases.purchases_current_year_dollars"))}
      />
      <SummaryStat
        label={`Sales - ${year}`}
        value={dollar(_.get(stats, "sales.sales_current_year_dollars"))}
      />
      <SummaryStat
        label={`Purchases - ${year - 1}`}
        value={dollar(_.get(stats, "purchases.purchases_last_year_dollars"))}
      />
      <SummaryStat
        label={`Sales - ${year - 1}`}
        value={dollar(_.get(stats, "sales.sales_last_year_dollars"))}
      />
    </div>
  );
}

StandardCompanyStatsSummary.propTypes = {
  stats: T.shape({})
};

function RepairStationStatsSummary({ stats }) {
  const year = moment().year();

  return (
    <div>
      <SummaryStat
        label={`# Repairs Sent - ${year}`}
        value={number(_.get(stats, "repairs.repairs_current_year_count"))}
      />
      <SummaryStat
        label={`$ Repairs Sent - ${year}`}
        value={dollar(_.get(stats, "repairs.repairs_current_year_dollars"))}
      />
      <SummaryStat
        label={`# Repairs Sent - ${year - 1}`}
        value={number(_.get(stats, "repairs.repairs_last_year_count"))}
      />
      <SummaryStat
        label={`$ Repairs Sent - ${year - 1}`}
        value={dollar(_.get(stats, "repairs.repairs_last_year_dollars"))}
      />
      <SummaryStat
        label="# Total Warranties - 12 mos."
        value={numberAndPercent(
          _.get(stats, "repairs.warranties_12_months_count"),
          _.get(stats, "repairs.warranties_12_months_percent")
        )}
      />
      <SummaryStat
        label="# Warranties Accepted - 12 mos."
        value={numberAndPercent(
          _.get(stats, "repairs.warranties_approved_12_months_count"),
          _.get(stats, "repairs.warranties_approved_12_months_percent")
        )}
      />
      <SummaryStat
        label="# Warranties Denied - 12 mos."
        value={numberAndPercent(
          _.get(stats, "repairs.warranties_denied_12_months_count"),
          _.get(stats, "repairs.warranties_denied_12_months_percent")
        )}
      />
      <SummaryStat
        label="# Units in Stock Tagged By"
        value={number(_.get(stats, "repairs.units_in_stock_tagged_by_qty"))}
        offset={4}
      />
      <SummaryStat
        label="# Units At Shop"
        value={number(_.get(stats, "repairs.units_at_shop_qty"))}
      />
    </div>
  );
}

RepairStationStatsSummary.propTypes = {
  stats: T.shape({})
};



// WEBPACK FOOTER //
// ./app/modules/shared/components/StatsTooltip/CompanyStats/Summary.jsx